"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n"], ["\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTabs = require("react-tabs");

var _Col = require("../Col");

var _Col2 = _interopRequireDefault(_Col);

var _Row = require("../Row");

var _Row2 = _interopRequireDefault(_Row);

var _Rows = require("../Rows");

var _Rows2 = _interopRequireDefault(_Rows);

var _propTypes = require("./propTypes");

var _Styled = require("./Styled");

var _Styled2 = _interopRequireDefault(_Styled);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledCol = (0, _styledComponents2.default)(function (_ref) {
  var disableSidebar = _ref.disableSidebar,
      rest = _objectWithoutProperties(_ref, ["disableSidebar"]);

  return _react2.default.createElement(_Col2.default, rest);
})(_templateObject);

var Tabs = function Tabs(props) {
  var CustomLink = props.customLink;
  var CustomPanel = props.customPanel;
  var fullWidth = 12;
  var renderedLinks = [];
  var renderedPanels = [];
  var sidebarWidth = props.disableSidebar ? 0 : props.sidebarWidth;
  var contentWidth = fullWidth - sidebarWidth;
  var realContentWidth = contentWidth > 0 ? contentWidth : fullWidth;

  for (var i = 0; i < props.items.length; i += 1) {
    var _props$items$i = props.items[i],
        link = _props$items$i.link,
        panel = _props$items$i.panel;
    renderedLinks.push(_react2.default.createElement(_reactTabs.Tab, {
      key: i
    }, CustomLink ? _react2.default.createElement(CustomLink, null, link) : link));
    renderedPanels.push(_react2.default.createElement(_reactTabs.TabPanel, {
      key: i
    }, CustomPanel ? _react2.default.createElement(CustomPanel, null, panel) : panel));
  }

  var linksCol = _react2.default.createElement(StyledCol, {
    disableSidebar: props.disableSidebar,
    md: props.sidebarWidth,
    style: {
      display: props.disableSidebar ? 'none' : undefined
    }
  }, props.title, _react2.default.createElement(_reactTabs.TabList, null, renderedLinks));

  var panelsCol = _react2.default.createElement(StyledCol, {
    md: realContentWidth
  }, renderedPanels);

  return _react2.default.createElement(_Styled2.default, {
    bordered: props.bordered,
    defaultIndex: props.defaultIndex,
    inlineLinks: props.inlineLinks,
    onSelect: props.onSelect,
    selectedIndex: props.selectedIndex,
    sidebarOnRight: props.sidebarOnRight,
    sidebarWidth: props.sidebarWidth,
    style: props.style
  }, _react2.default.createElement(_Rows2.default, {
    fluid: true
  }, _react2.default.createElement(_Row2.default, null, !props.sidebarOnRight && linksCol, panelsCol, props.sidebarOnRight && linksCol)));
};

Tabs.defaultProps = _propTypes.tabsDefaultProps;
Tabs.propTypes = _propTypes.tabsPropTypes;
exports.default = Tabs;